/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const styles = css`
    margin-bottom: var(--layout-spacing-32);

    .same-accessories__title {
        display: flex;
        gap: var(--layout-spacing-8);
        align-items: center;
        ${theme.typography.body_large}
        color: var(--colors-text-secondary);
        margin-bottom: var(--layout-spacing-8);
    }

    .same-accessories__condition-icon svg {
        fill: var(--colors-surface-accent-inverse);
    }

    .same-accessories__description {
        ${theme.typography.body_small}
    }
`;
